<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ isEditing
            ? $t('Редактирование метаданных страницы')
            : $t('Создание страницы') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <v-row>
          <v-col>
            <ValidationObserver ref="page">
              <validatable-text-input
                  v-model="page.tag"
                  v-test="{ input: 'tag' }"
                  :readonly="!isMainAdmin"
                  :rules="{
                    required: true,
                    regex: /^[a-zA-Z0-9_-]*$/ }"
                  :label="$t('Идентификатор')"
                  prepend-icon="tag" />
              <validatable-text-input
                  v-model="page.name"
                  v-test="{ input: 'name' }"
                  rules="required"
                  :label="$t('Наименование страницы')"
                  prepend-icon="title" />
              <validatable-text-input
                  v-model="page.description"
                  v-test="{ input: 'description' }"
                  rules="required"
                  :label="$t('Описание страницы')"
                  prepend-icon="description" />
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { STATIC_PAGES } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            id: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        page: {
          tag: null,
          name: null,
          description: null
        }
      }
    },
    computed: {
      ...mapState(STATIC_PAGES.NAMESPACE, {
        pageInfo: state => (state[STATIC_PAGES.STATE.CURRENT_STATIC_PAGE] || {})
      }),
      isEditing () {
        return !!this.dialogProp.id
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (vm.dialogProp.id) {
          vm.getFullPageInfo()
        }
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(STATIC_PAGES.NAMESPACE, {
        getFullPageInfoAction: STATIC_PAGES.ACTIONS.GET_FULL_PAGE_INFO,
        addPageAction: STATIC_PAGES.ACTIONS.ADD_PAGE,
        editPageAction: STATIC_PAGES.ACTIONS.EDIT_PAGE,
        clearFullPageInfoAction: STATIC_PAGES.ACTIONS.CLEAR_FULL_PAGE_INFO
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearFullPageInfoAction()
          ])
      },
      getFullPageInfo: async function () {
        try {
          this.isLoading = true
          await this.getFullPageInfoAction({
            tag: this.dialogProp.id
          })
          this.page.tag = this.pageInfo.tag
          this.page.name = this.pageInfo.name
          this.page.description = this.pageInfo.description
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      continueOperation: async function () {
        const result = await this.$refs.page.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          if (this.isEditing) {
            await this.editPage()
          } else {
            await this.addPage()
          }
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      addPage: async function () {
        try {
          this.isLoading = true
          await this.addPageAction(this.page)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      editPage: async function () {
        try {
          this.isLoading = true
          await this.editPageAction({
            page: this.page,
            tag: this.dialogProp.id
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
